import Image from "gatsby-image";
import React from "react";
import OgImage from "../../../../assets/images/blog/article_15/brand-hero_og.png";
import {useAuthorsData} from "../../Authors/useAuthorsData";
import {ArticlePhotos} from "./ArticlePhotos";

export const ArticleData = () => {
  const images = ArticlePhotos();
  const authors = useAuthorsData();

  return {
    date:              "07.12.2021r",
    category:          "",
    title:             "Marketing też ma twarz, czyli kim jest brand hero",
    SEO_title:         "Marketing też ma twarz, czyli kim jest brand hero",
    description:
                       <>
                         Kto nie zna fioletowej krowy Milka czy Serca i Rozumu reklamujących popularną sieć telefonii komórkowej w Polsce? To właśnie oni - brand heroes! Dosłownie bohaterowie marki, którzy są personifikacją lub po prostu odzwierciedleniem wartości, z jakimi identyfikuje się firma. Czasem nazywa się ich również maskotką marki.
                         <br/>
                         <br/>
                         Brand hero może być postacią realistyczną, ludzką (np. Henio i Krysia - eksperci TESCO) lub zwierzęcą (np. żubr w puszczy reklamujący piwo). Częściej jednak spotykamy się z formami bardziej wyimaginowanymi - od zwierząt o ludzkich cechach (Miś Plush z Plusa) po abstrakcyjne formy (Mały Głód firmy Danio). To właśnie te postacie, które są najbardziej ludzkie i najbardziej bliskie naszym charakterom, działają na nas najbardziej skutecznie!
                       </>,
    seo:               "Kto nie zna fioletowej krowy Milka czy Serca i Rozumu reklamujących popularną sieć telefonii komórkowej w Polsce? To właśnie oni - brand heroes! Dosłownie bohaterowie marki, którzy są personifikacją lub po prostu odzwierciedleniem wartości, z jakimi identyfikuje się firma. Czasem nazywa się ich również maskotką marki.",
    slug:              "/blog/brand-hero",
    image:             OgImage,
    authors:           [
      authors.DariaPyziak,
    ],
    hero:              (
                         <Image
                           alt=""
                           objectPosition={"center"}
                           objectFit={"contain"}
                           fluid={images.hero.childImageSharp.fluid}
                         />
                       ),
    text:              {
      first:  {
        title: "Jak to się wszystko zaczęło?",
        text:  <>
                 Na początku brand heroes były kojarzone z postaciami takimi jak tygrys Tony z opakowań płatków śniadaniowych Kellogg’s. Nie wyobrażano sobie wtedy, by maskotki mogły reklamować produkty o mniej infantylnym charakterze, skierowane do dorosłych odbiorców. Wszystko zmienił producent opon!<br/> <br/>
                 Prawdopodobnie pierwszym brand hero był <strong>francuski Bibendum.</strong> Tę postać kojarzymy z pewnością lepiej pod nazwą <strong>„ludzik Michelin”.</strong> Powstał on końcem XIX wieku i&nbsp;był antropomorficzną wieżyczką opon. W&nbsp;1894 roku zaprezentowano go po raz pierwszy podczas światowej wystawy w Lyonie. Jego popularność wzrastała w&nbsp;ekspresowym tempie, a&nbsp;marka tylko na tym korzystała. <br/> <br/>
                 Na przestrzeni lat <strong>rosła rola storytellingu</strong> w działaniach reklamowych. Marketingowcy więc poszukiwali kogoś, kto tę historię opowie w taki sposób, by konsumenci chcieli jej wysłuchać. Sympatyczna maskotka nadawał się do tego zadania idealnie.
               </>,
      },
      second: {
        title: "Prosty i skuteczny przekaz",
        text:  <>Ta forma marketingu posiada wiele zalet. To nie tylko kreowanie pozytynwego wizerunku. <strong>Dlaczego więc warto zainwestować w brand hero w reklamie?</strong></>,
      },
      third:  {
        title: "Dobry brand hero… czyli jaki?\n",
        text:  <>
                 Stworzenie maskotki musi wiązać się z dokładną analizą wartości marki, jej tożsamości i wizerunku. Powinniśmy też określić cel, dla którego chcemy stworzyć brand hero. Warto również dokładnie wiedzieć, do kogo chcemy trafić z komunikacją. Bohater i grupa docelowa musi ze sobą dzielić cechy i problemy. <br/> <br/>
                 Budowę charakteru naszej postaci najlepiej oprzeć na konkretnym archetypie. Istnieje <strong>12 różnych archetypów</strong> - wzorców postaci, które charakteryzują się indywidualnymi cechami i funkcjami.
               </>
      },
      fourth: {
        title: "A może czarny charakter?\n",
        text:  "Nasza postać nie zawsze musi być dobrym bohaterem. Najbardziej znanym przykładem antagonisty w reklamie jest Mały Głód - maskotka marki Danio. Prezentuje on przeciwieństwo tego, co komunikuje marka. Jego fenomen polega na tym, że „sytość jogurtu” uchodzi za skuteczny sposób walki z głodem - czyli na pozbycie się Małego Głoda."
      },
      fifth:  {
        title: "Emocje to podstawa!",
        text:  <>
                 Jeśli Twoja firma w swoich kampaniach nie odwołuje się do <strong>emocji,</strong> a jej przewagę rynkową zapewniają jedynie korzyści funkcjonalne, brand hero nie wiele Ci pomoże. Ta kreacja służy do budowania relacji opartych właśnie na emocjach. <br/><br/>
                 <a href="https://interactivevision.pl/realizacje/heating" title="Realizacja interactivevision - Hituś">Zobacz, jak wygląda Hituś</a> - bohater marki w naszym wykonaniu. Nawiązuje do branży, którą reprezentuje, jest pozytywny i wesoły, a do tego spójny z pozostałymi elementami identyfikacji wizualnej firmy. <br/> <br/>
                 Potrzebujesz podobnego projektu? Napisz do nas! Zaprojektujemy dla Ciebie postać, która będzie reprezentowała wartości i zalety Twojej marki.
               </>
      },
    },
    list:              {
      first: {
        title:   "Prosty i skuteczny przekaz",
        text:    <>Ta forma marketingu posiada wiele zalet. To nie tylko kreowanie pozytywnego wizerunku. <strong>Dlaczego więc warto zainwestować w brand hero w reklamie?</strong></>,
        content: [
          "Ułatwia nawiązywanie relacji emocjonalnej z klientem. Ciężej nam nawiązać kontakt z kimś, kogo twarzy nie jesteśmy w stanie zobaczyć. Bohater - oprócz twarzy - nadaje marce bardziej ludzki charakter, a przez błyskotliwe żarty zmniejsza dystans między nim a odbiorcą.",
          "Wzmacnia wiarygodność przekazów samej marki - odbiorcy identyfikują wartości, jakie reprezentuje z wartościami, którymi kieruje się firma.",
          "Przy wykorzystaniu storytellingu ułatwia sposób przedstawiania produktów i usług oraz podkreśla ich korzyści.",
          "Zwiększa zasięgi poprzez wzrost liczby udostępnień. Dobrze prowadzona komunikacja z wykorzystaniem brand hero powinna prowadzić do zwiększenia udostępniania treści między samymi odbiorcami.",
          "Ułatwia odbiorcom zapamiętanie przekazu reklamowego.",
          "Pomaga w podejmowaniu decyzji zakupowych - Klient zamiast zastanawiać się, czy jest to najlepsza opcja, może zastanowić się, czy lubi Twoją maskotkę i wartości, które niesie.",
        ]
      }
    },
    imagesWithCaption: {
      first:  {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_1.childImageSharp.fluid}
                   />
                 ),
        caption: "Plakat autorstwa Mariusa Rossillona (O’Galop) przedstawiający Bibenduma",
        width:   496,
      },
      second: {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_2.childImageSharp.fluid}
                   />
                 ),
        caption: <>Źródło tekstowe: <a href="https://midea.pl/archetypy-marki/" target="_blank" rel="noreferrer">https://midea.pl/archetypy-marki/</a></>,
        width:   1000,
      },
      third:  {
        img:     (
                   <Image
                     alt=""
                     objectPosition={"center"}
                     objectFit={"contain"}
                     fluid={images.img_3.childImageSharp.fluid}
                   />
                 ),
        caption: <>Źródło: <a href="https://www.se.pl/wiadomosci/galeria/may-god-porywa-blogerki/gg-wLb9-N8mR-oiqY/gp-kDNu-Xv3a-Vzjf" target="_blank" rel="noreferrer">https://www.se.pl/wiadomosci/galeria/may-god-porywa-blogerki/gg-wLb9-N8mR-oiqY/gp-kDNu-Xv3a-Vzjf</a></>,
        width:   664,
      },
    },
  };
};
